













import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ProductDetailsCategories',
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    categoryList(): string {
      return this.categories.join(' / ')
    },
  },
})
